import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" viewBox="0 0 20 20" {...props}><g transform="translate(3 3)" fill="#DADADA"><path id="Rectangle" d="M0 6h14v2H0zM0 12h14v2H0zM0 0h14v2H0z" /></g></svg>);